module.exports = __webpack_public_path__ + "static/track-6d324b670eb812809c788e22d672295b.svg";